export const wawancaraQuestionGroups = [
  {
    id: 'subjek_hukum',
    label: 'Subjek Hukum',
    answerType: 'conformity',
    questions: [
      { id: 'subjek_hukum_kkprl', text: 'Apakah Subjek Hukum Sesuai dengan KKPRL terbit' },
    ],
  },
  {
    id: 'kemajuan_perizinan',
    label: 'Kemajuan Perizinan',
    answerType: 'textarea',
    questions: [
      { id: 'persetujuan_lingkungan', text: 'Persetujuan lingkungan' },
      { id: 'perizinan_berusaha', text: 'Perizinan berusaha' },
    ],
  },
  {
    id: 'kewajiban_kkprl',
    label: 'Kewajiban KKPRL',
    answerType: 'completion',
    questions: [
      { id: 'kewajiban_01', text: 'Memperhatikan keberlanjutan kehidupan dan penghidupan Masyarakat' },
      { id: 'kewajiban_02', text: 'Memberikan akses untuk nelayan kecil yang sudah secara rutin melintas' },
      { id: 'kewajiban_03', text: 'Menghormati kepentingan pihak lain yang melakukan kegiatan atau Pemanfaatan Ruang di sekitarnya' },
      { id: 'kewajiban_04', text: 'Melakukan kegiatan secara ramah lingkungan' },
      { id: 'kewajiban_05', text: 'Menjaga kelestarian ekosistem laut dan melakukan rehabilitasi sumber daya yang mengalami kerusakan' },
      { id: 'kewajiban_06', text: 'Menjaga kehidupan dan alur migrasi biota laut' },
      { id: 'kewajiban_07', text: 'Memberikan akses/tempat berlindung kepada siapapun dalam kondisi darurat' },
      { id: 'kewajiban_08', text: 'Melibatkan dan memberdayakan Masyarakat sekitar lokasi kegiatan/usaha' },
      { id: 'kewajiban_09', text: 'Membongkar Bangunan dan Instalasi di Laut apabila masa berlaku telah habis dan kegiatan/usaha tidak dilanjutkan lagi' },
      { id: 'kewajiban_10', text: 'Tidak menimbulkan konflik sosial' },
      { id: 'kewajiban_11', text: 'Tidak menimbulkan gangguan bagi pelaksanaan kepentingan keselamatan, pertahanan keamanan, dan memperhatikan kepentingan nasional' },
      { id: 'kewajiban_12', text: 'Menyampaikan laporan secara tertulis setiap 1 (satu) tahun kepada Menteri' },
      { id: 'kewajiban_13', text: 'Bermitra dengan pengelola Kawasan Konservasi di Laut dalam rangka program kemitraan dan bina lingkungan dalam hal lokasi kegiatan berada dalam Kawasan Konservasi di Laut' },
      { id: 'kewajiban_14', text: 'Melaporkan pendirian dan/atau penempatan Bangunan dan Instalasi di Laut kepada instansi yang menyelenggarakan urusan pemerintahan di bidang hidrografi dan oseanografi' },
      { id: 'kewajiban_15', text: 'Menyediakan prasarana dan sarana pencegahan pencemaran dan pencegahan kerusakan sumber daya ikan serta lingkungannya' },
    ],
  },
]

export function createEmptyInterviewAnswers() {
  return wawancaraQuestionGroups.reduce((answers, group) => {
    group.questions.forEach((question) => {
      answers[question.id] = { jawaban: '', penjelasan: '' }
    })
    return answers
  }, {})
}
